import React from 'react';
import {
    ConnectorEnum,
    useValidateConnectionSettingsMutation,
    ValidateConnectionSettingsMutation,
} from '../generated/graphql';
import { toast } from 'react-toastify';
import Toast from '@oberoninternal/travelbase-ds/components/feedback/Toast';
import Body from '@oberoninternal/travelbase-ds/components/primitive/Body';
import { FormattedMessage, useIntl } from 'react-intl';
import gql from 'graphql-tag';
import { FetchResult } from '@apollo/client';

export const validatePartnerConnectorSettingsMutation = gql`
    mutation ValidateConnectionSettings($input: ValidateConnectorSettingsInput!) {
        validateConnectorSettings(input: $input) {
            success
        }
    }
`;
export const useConnectionValidator = () => {
    const [validate] = useValidateConnectionSettingsMutation();
    const { formatMessage } = useIntl();

    const validateConnectionSettings = async (connector: ConnectorEnum, settings: string) => {
        const result = await validate({
            variables: {
                input: {
                    connector,
                    settings,
                },
            },
        }).then((res: FetchResult<ValidateConnectionSettingsMutation>) => res.data?.validateConnectorSettings.success);

        toast(
            !toast.isActive('validateSettings') ? (
                result ? (
                    <Toast variant="success" title={formatMessage({ defaultMessage: "Goed"})}>
                        <Body variant="small">
                            <FormattedMessage defaultMessage="De configuratie is geldig" />
                        </Body>
                    </Toast>
                ) : (
                    <Toast variant="error" title={formatMessage({ defaultMessage: "Fout"})}>
                        <Body variant="small">
                            <FormattedMessage defaultMessage="De configuratie is niet geldig" />
                        </Body>
                    </Toast>
                )
            ) : null,
            {
                autoClose: 3000,
                toastId: 'validateSettings',
            }
        );

        return result;
    };

    return { validateConnectionSettings };
};
